import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "green-rightArrow",
  "use": "green-rightArrow-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"green-rightArrow\"><path d=\"M519.168 829.44 837.12 512 519.168 194.56 688.128 512z\" fill=\"#00FFBE\" /><path d=\"M519.168 829.44 688.128 512l-168.96-317.44L688.128 512zM186.88 829.44 504.832 512 186.88 194.56 355.328 512z\" fill=\"#00FFBE\" /><path d=\"M186.88 829.44 355.328 512 186.88 194.56 355.328 512z\" fill=\"#00FFBE\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol